import React from 'react'

import {
    TabsContainer,
    TabsContentHeader,
    TabsContentHeadline,
    TabsContentToggleIcon,
    TabsContent,
    TabContentDescription
} from '../StyledComponents/Plants/PlantTabs'

import PlantCareRows from './PlantCareRows'

class PlantTabContainer extends React.Component {
    constructor(props) {
        super(props)

        this.toggleCare = this.toggleCare.bind(this)
        this.toggleDescription = this.toggleDescription.bind(this)
        this.state = {
            careActive: true,
            descriptionActive: true,
        }
    }

    toggleCare() {
        this.setState({
            careActive: !this.state.careActive,
        })
    }

    toggleDescription() {
        this.setState({
            descriptionActive: !this.state.descriptionActive,
        })
    }

    renderCareContent() {
        const { plant } = this.props

        if (!this.state.careActive) {
            return <TabsContent><hr /></TabsContent>
        }

        return (
            <TabsContent>
                <PlantCareRows plant={plant} />
            </TabsContent>
        )
    }

    renderDescriptionContent() {
        if (!this.state.descriptionActive) {
            return <TabsContent><hr /></TabsContent>
        }

        const { plant } = this.props

        return (
            <TabsContent>
                <TabContentDescription
                    dangerouslySetInnerHTML={{ __html: plant.description_html }}
                />
            </TabsContent>
        )
    }

    render() {
        return (
            <TabsContainer>
                <TabsContentHeader onClick={this.toggleCare}>
                    <TabsContentHeadline>Steckbrief</TabsContentHeadline>
                    <TabsContentToggleIcon isOpened={this.state.careActive} name="sort-down" size="lg" />
                </TabsContentHeader>
                {this.renderCareContent()}
                <TabsContentHeader onClick={this.toggleDescription}>
                    <TabsContentHeadline>Beschreibung</TabsContentHeadline>
                    <TabsContentToggleIcon isOpened={this.state.descriptionActive} name="sort-down" size="lg" />
                </TabsContentHeader>
                {this.renderDescriptionContent()}
            </TabsContainer>
        )
    }
}

export default PlantTabContainer



// WEBPACK FOOTER //
// ./src/components/Plant/PlantTabContainer.js